import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑精选优质内容，为你推荐最值得关注的吃瓜话题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.slice(0, 7).map((card) => (
            <article key={card.title} className="rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-colors group cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={cardItems.indexOf(card) > 3 ? 'lazy' : undefined}
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{card.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}